interface props {
  children: string | React.ReactNode;
  color?: string;
  active?: boolean;
  setActive?: Function;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  className?: string;
  noHover?: boolean;
}

export function ButtonV1({
  children,
  color,
  active,
  setActive,
  onClick,
  type,
  className,
}: props) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (setActive) {
      setActive();
    }
  };

  const getColorClasses = () => {
    switch (color) {
      case "blue":
        return "bg-red-600 hover:bg-red-700";
      case "red":
        return "bg-red-600 hover:bg-red-700";
      case "green":
        return "bg-green-600 hover:bg-green-700";
      default:
        return "bg-[#DA1A42] hover:bg-[#a90027]";
    }
  };

  return (
    <button
      type={type || "button"}
      onClick={handleClick}
      className={`w-full my-1 flex gap-1 justify-center items-center capitalize text-white p-2 px-4 border-none rounded-xl whitespace-nowrap ${getColorClasses()} ${
        className ?? ""
      }`}
    >
      {children}
    </button>
  );
}

export function ButtonV2({ children, color, active, setActive, onClick }: props) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (setActive) {
      setActive();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`w-full my-1 flex gap-1 justify-center items-center capitalize p-2 px-4 rounded-xl whitespace-nowrap border border-[#DA1A42] text-[#DA1A42] hover:bg-[#DA1A42] hover:text-white`}
    >
      {children}
    </button>
  );
}

export function ButtonV3({ children, color, active, setActive, onClick, type }: props) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (setActive) {
      setActive();
    }
  };

  return (
    <button
      type={type || "button"}
      onClick={handleClick}
      className={`w-full my-1 flex gap-1 justify-center items-center capitalize p-2 px-4 border-none rounded-xl whitespace-nowrap hover:bg-[#a90027] text-[#DA1A42] hover:text-white`}
    >
      {children}
    </button>
  );
}

export function ButtonV4({ children, color, active, setActive, onClick, className, noHover}: props) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (setActive) {
      setActive();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`w-max my-1 flex gap-1 justify-center items-center capitalize p-2 px-4 border-none rounded-xl whitespace-nowrap ${noHover ? "" : "hover:bg-[#a90027] hover:text-white"} text-[#DA1A42] ${className ?? ""}`}
    >
      {children}
    </button>
  );
}
